import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import NetflixTitle from './NetflixTitle';
import ProfilePage from './profilePage/profilePage';
import Browse from './browse/browse';
import WorkExperience from './pages/WorkExperience';
import Recommendations from './pages/Recommendations';
import Skills from './pages/Skills';
import Projects from './pages/Projects';
import ContactMe from './pages/ContactMe';
import Layout from './Layout';
import Music from './pages/Music';
import Photograpgy from './pages/Photography';
import Blogs from './pages/Blogs';
import Certifications from './pages/Certifications';
import PageNotFound from './pages/PageNotFound';
import Seo from './Seo';

const App: React.FC = () => {
  return (
    <>
      <Seo />
      <Routes>
        <Route path="/" element={<NetflixTitle />} />
        <Route path="/browse" element={<Browse />} />
        <Route path="/profile/:profileName" element={<Layout><ProfilePage /></Layout>} />
        <Route path="/work-experience" element={<Layout><WorkExperience /></Layout>} />
        <Route path="/recommendations" element={<Layout><Recommendations /></Layout>} />
        <Route path="/skills" element={<Layout><Skills /></Layout>} />
        <Route path="/projects" element={<Layout><Projects /></Layout>} />
        <Route path="/contact-me" element={<Layout><ContactMe /></Layout>} />
        <Route path="/music" element={<Layout><Music /></Layout>} />
        <Route path="/photography" element={<Layout><Photograpgy /></Layout>} />
        <Route path="/blogs" element={<Layout><Blogs /></Layout>} />
        <Route path="/certifications" element={<Layout><Certifications /></Layout>} />
        {/* Legacy redirects. Do not include these URLs in sitemap.xml. */}
        <Route path="/experience" element={<Navigate to="/work-experience" replace />} />
        <Route path="/contact" element={<Navigate to="/contact-me" replace />} />
        {/* Catch all unmatched routes */}
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </>
  );
};

export default App;
